import script from "./CompanyActive.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompanyActive.vue?vue&type=script&setup=true&lang=ts"

import "./CompanyActive.vue?vue&type=style&index=0&id=5ee71b74&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ee71b74"]])

export default __exports__